import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'glass-nav py-3' : 'bg-transparent py-5'}`} data-id="element-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-201">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 group" data-id="element-202">
          <div className="w-12 h-12 rounded-lg overflow-hidden shadow-lg border border-white/10 group-hover:shadow-gold/20 transition-all duration-300" data-id="element-203">
            <img src="https://cdn.magicpatterns.com/uploads/hvr54fUgpvRXPZnwmrPfcj/grandtown_logo.jpg" alt="Grand Town Logo" className="w-full h-full object-cover" data-id="element-204" />
          </div>
          <span className={`font-playfair font-semibold text-xl tracking-wide transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white drop-shadow-md'}`} data-id="element-205">
            Grand Town
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-206">
          <div className="flex items-center gap-8" data-id="element-207">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wider uppercase transition-colors duration-300 hover:text-gold ${isScrolled ? 'text-charcoal/80' : 'text-white/90 drop-shadow-sm'}`} data-id="element-208">
                {link.name}
              </a>)}
          </div>
          <a href="#contacto" className={`px-6 py-2.5 rounded-full text-sm font-semibold tracking-wide transition-all duration-300 border ${isScrolled ? 'bg-gold text-white border-gold hover:bg-gold-hover hover:border-gold-hover shadow-md hover:shadow-lg' : 'bg-white/10 text-white border-white/30 backdrop-blur-sm hover:bg-white hover:text-charcoal'}`} data-id="element-209">
            Diagnóstico
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-210">
          {mobileMenuOpen ? <X className={isScrolled ? 'text-charcoal' : 'text-white'} size={24} data-id="element-211" /> : <Menu className={isScrolled ? 'text-charcoal' : 'text-white'} size={24} data-id="element-212" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 md:hidden flex flex-col" data-id="element-213">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="px-6 py-4 border-b border-gray-50 text-charcoal font-medium hover:bg-pearl hover:text-gold transition-colors" data-id="element-214">
              {link.name}
            </a>)}
          <div className="p-6" data-id="element-215">
            <a href="https://wa.me/529843115669?text=Hola%21%20Me%20gustaria%20contactar%20a%20un%20asesor" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center px-6 py-3 bg-gold text-white rounded-full font-semibold shadow-md" data-id="element-216">
              Contactar a un asesor
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
}